import add from "date-fns/add";
import isAfter from "date-fns/isAfter";
import setYear from "date-fns/setYear";
import sub from "date-fns/sub";
export const canMoveToPreviousMonth = (activeDate, minDate) => {
  if (!minDate) {
    return true;
  }
  const prevMonthDate = sub(activeDate, {
    months: 1
  });
  const minDateObject = convertDatePickerDateToDate(minDate);
  return prevMonthDate >= minDateObject;
};
export const canMoveToNextMonth = (activeDate, maxDate) => {
  if (!maxDate) {
    return true;
  }
  const nextMonthDate = add(activeDate, {
    months: 1
  });
  const maxDateObject = convertDatePickerDateToDate(maxDate);
  return nextMonthDate <= maxDateObject;
};
export const convertDatePickerDateToDate = _ref => {
  let {
    year,
    month,
    day
  } = _ref;
  return new Date(year, month, day);
};
export const getAdjustedDateOnYearChange = (activeDate, newYear, minDate, maxDate) => {
  const newDate = setYear(activeDate, newYear);
  const maxDateObj = maxDate ? convertDatePickerDateToDate(maxDate) : undefined;
  const minDateObj = minDate ? convertDatePickerDateToDate(minDate) : undefined;
  if (maxDateObj && isAfter(newDate, maxDateObj)) {
    return maxDateObj;
  }
  if (minDateObj && isAfter(minDateObj, newDate)) {
    return minDateObj;
  }
  return newDate;
};
//# sourceMappingURL=datePickerFrameUtil.js.map